import React from 'react';
import PropTypes from 'prop-types';
import { debounce } from 'lodash';
import { CustomPicker, HuePicker } from 'react-color';
import { Saturation } from 'react-color/lib/components/common/Saturation';
import { FormattedMessage } from 'react-intl';
import { H6 } from '@luigiclaudio/ga-baseline-ui/typography';
import CustomSwatches from './CustomSwatches';
import SaturationContainer from './SaturationContainer';
import HuePickerContainer from './HuePickerContainer';
import CustomSwatchesContainer from './CustomSwatchesContainer';
import HuePickerPointer from './HuePickerPointer';
import CustomColorPickerContainer from './CustomColorPickerContainer';

const CustomColorPicker = ({ color, onChange, pickerWidth, ...props }) => {
    const onChangeComplete = debounce(onChange, 100);

    return (
        <CustomColorPickerContainer pickerWidth={pickerWidth}>
            <H6 color="muted">
                <FormattedMessage id="customColorPicker.pureHues" />
            </H6>
            <CustomSwatchesContainer>
                <CustomSwatches onChange={onChangeComplete} />
            </CustomSwatchesContainer>
            <H6 color="muted">
                <FormattedMessage id="customColorPicker.hues" />
            </H6>
            <HuePickerContainer>
                <HuePicker
                    color={color}
                    height={20}
                    onChange={onChangeComplete}
                    pointer={HuePickerPointer}
                    width="100%"
                    {...props}
                />
            </HuePickerContainer>
            <H6 color="muted">
                <FormattedMessage id="customColorPicker.saturation" />
            </H6>
            <SaturationContainer>
                <Saturation color={color} onChange={onChangeComplete} {...props} />
            </SaturationContainer>
        </CustomColorPickerContainer>
    );
};

CustomColorPicker.propTypes = {
    color: PropTypes.string.isRequired,
    onChange: PropTypes.func.isRequired,
    pickerWidth: PropTypes.number,
};

CustomColorPicker.defaultProps = {
    pickerWidth: undefined,
};

export default CustomPicker(CustomColorPicker);
